// Tipos de pregunta de una encuesta. Ver App\Models\SurveyQuestionType en el
// backend: la configuración por defecto de cada tipo tiene que coincidir.
export const SurveyQuestionTypeKeys = {
  stars: 'stars',
  scale: 'scale',
  emoji: 'emoji',
  single_choice: 'single_choice',
  yes_no: 'yes_no',
  text: 'text',
}

export const defaultSurveyQuestionSettings = (type) =>
  ({
    stars: { max: 5 },
    scale: { min: 1, max: 10, min_label: '', max_label: '' },
    emoji: { levels: 5 },
    single_choice: { options: ['', ''] },
    yes_no: {},
    text: { max_length: 1000 },
  }[type] || {})

// Caritas de peor a mejor. Con 3 niveles se usan la primera, la del medio y la
// última.
const EMOJIS = ['😞', '🙁', '😐', '🙂', '😄']
export const surveyEmojis = (levels) =>
  levels === 3 ? [EMOJIS[0], EMOJIS[2], EMOJIS[4]] : EMOJIS
